
export default {
    
    name: 'periodo',
    component: () => import(/* webpackChunkName: "Period" */ '@/modules/sievi/layouts/SieviLayout.vue'),
    children: [
        {
            path: '',
            name: 'period.home',
            component: () => import(/* webpackChunkName: "Period-list" */ '@/modules/sievi/views/Period.vue'),
        },
        {
            path: ':id',
            name: 'period.docente',
            component: () => import(/* webpackChunkName: "Period-list" */ '@/modules/sievi/views/Period.vue'),
            props: ( route ) => {
                return {
                    id: Number(route.params.id)
                }
            }
        },
        {
            path: 'responsable/:id/:campusId/:hfsId/:programId/:teacherId/:contractId',
            name: 'period.responsable',
            component: () => import(/* webpackChunkName: "Periods-reponsable" */ '@/modules/sievi/views/responsable/periodos/List.vue'),
            props: ( route ) => {
                return {
                    id: Number(route.params.id),
                    campusId: Number(route.params.campusId),
                    hfsId: Number(route.params.hfsId),
                    programId: Number(route.params.programId),
                    teacherId: Number(route.params.teacherId),
                    contractId: Number(route.params.contractId),
                }
            }
        },
        {
            path: 'auditor/:campusId/:programId/:teacherId/:contractId',
            name: 'period.auditor',
            component: () => import(/* webpackChunkName: "Periods-auditor" */ '@/modules/sievi/views/auditor/periodos/List.vue'),
            props: ( route ) => {
                return {
                    campusId: Number(route.params.campusId),
                    programId: Number(route.params.programId),
                    teacherId: Number(route.params.teacherId),
                    contractId: Number(route.params.contractId),
                }
            }
        },
        {
            path: 'crear',
            name: 'period.create',
            component: () => import(/* webpackChunkName: "Period-create" */ '@/modules/sievi/views/administrador/periodo/Create.vue'),
        },
        {
            path: 'editar/:id',
            name: 'period.edit',
            component: () => import(/* webpackChunkName: "Period-edit" */ '@/modules/sievi/views/administrador/periodo/Edit.vue'),
            props: ( route ) => {
                return {
                    id: Number(route.params.id)
                }
            }
        },
        {
            path: 'semanas/:id',
            name: 'period.weeks.edit',
            component: () => import(/* webpackChunkName: "Period-weeks" */ '@/modules/sievi/views/administrador/periodo/Weeks.vue'),
            props: ( route ) => {
                return {
                    id: Number(route.params.id)
                }
            }
        }
    ],

}